import { InGridToolBarButton } from "../editableGrid/editableGrid.js";
import React from "react";
export default class ToolBarContextMenu extends React.Component<{
    target: string;
    filter: string;
    buttons: InGridToolBarButton[];
    handleButtonClick: (button: InGridToolBarButton) => void;
    visible: boolean;
    open?: (p: ToolBarContextMenuOpenParams) => void;
}, any> {
    private contextMenu: kendo.ui.ContextMenu;

    constructor(props) {
        super(props);
    }

    public openContextMenu = (target: any) => {
        this.contextMenu.open(target);
    }

    componentDidMount() {
        if (this.props.visible)
            this.createContextMenu();
    }

    componentWillUnmount() {
        if (this.contextMenu)
            this.contextMenu.destroy();
    }

    private updateEnabledState = () => {
        for (let btn of this.props.buttons) {
            let enabled = btn.enabled(null);
            this.contextMenu.enable(`#${this.props.target}_${btn.id}`, enabled);
        }
    }

    private createContextMenu = () => {
        this.contextMenu = $(`#${this.props.target}_ToolbarContextMenu`).kendoContextMenu({
            target: "#" + this.props.target,
            filter: this.props.filter,
            open: (e) => {
                this.contextMenu.setOptions({
                    dataSource: this.getDataSource()
                });

                if (this.props.open) {
                    this.props.open({
                        e: e,
                        contextMenu: this.contextMenu,
                        buttons: this.props.buttons,
                        enable: (btn, enabled) => this.contextMenu.enable(`#${this.props.target}_${btn.id}`, enabled)
                    });
                }
                else
                    this.updateEnabledState();
            },
            dataSource: this.getDataSource()
        }).data("kendoContextMenu");
    }

    private getDataSource = () => {
        return this.props.buttons
            .filter(x => x.useContextMenu)
            .map(x => {
                return {
                    text: `<div id='${this.props.target}_${x.id}' style='font-weight: 400;'><span class='k-icon ${x.iconClass}' style='margin-right: 5px'></span>${x.caption}</div>`,
                    encoded: false,
                    select: (e) => {
                        e.preventDefault();
                        if ($(`#${this.props.target}_${x.id}`).hasClass('k-disabled'))
                            return;
                        this.props.handleButtonClick(x);
                    }
                };
            })
    }

    render() {
        return <div id={this.props.target + "_ToolbarContextMenu"} />
    }
}

export interface ToolBarContextMenuOpenParams {
    e: kendo.ui.ContextMenuOpenEvent;
    contextMenu: kendo.ui.ContextMenu;
    buttons: InGridToolBarButton[];
    enable: (btn: InGridToolBarButton, enabled: boolean) => void;
}